// extracted by mini-css-extract-plugin
module.exports = {"B":"B_B__XMzFX"};